module.exports = __webpack_public_path__ + "img/16.fc004afb.png";